import { render, staticRenderFns } from "./TechnicianView.vue?vue&type=template&id=96bfa5bc&scoped=true"
import script from "./TechnicianView.vue?vue&type=script&lang=js"
export * from "./TechnicianView.vue?vue&type=script&lang=js"
import style0 from "./TechnicianView.vue?vue&type=style&index=0&id=96bfa5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bfa5bc",
  null
  
)

export default component.exports